<template>
  <div class="content-carousel">
    <v-slick-carousel v-bind="sliderSettings" ref="carousel" @beforeChange="beforeSlideChange" @afterChange="afterSlideChange">
      <div class="stormtech-video-slide" v-for="(slide, index) in slidesState" :key="index">
        <!--ADS Bynder video-->
        <div v-if="slide.slideType == 'adsVideoBynder'"
          :class="['carousel-video ads-video-bynder', { 'playing': slide.isPlaying }]">
          <div class="play-btn-sm" @click="overlayClicked(slide)"></div>
          <div class="video-wrapper">
            <video controls :poster="slide.videoPoster" @loadedmetadata="videoLoaded"
              :ref="el => setVideoRef(index, el)">
              <source :src="slide.contentUrl" type="video/mp4" :aria-label="slide.Title" />
            </video>
          </div>
        </div>
        <!--ADS Youtube video-->
        <div v-else-if="slide.slideType == 'adsVideoYoutube'" class="carousel-video ads-video-yt">
          <iframe data-osano="ESSENTIAL" :src="slide.contentUrl" frameborder="0" allowfullscreen allow="encrypted-media; autoplay; fullscreen"
            :ref="el => setVideoRef(index, el)"></iframe>
        </div>
        <!--Library video-->
        <div v-else-if="slide.slideType == 'libraryVideo'"
          :class="['carousel-video ads-video-bynder', { 'playing': slide.isPlaying }]">
          <div class="play-btn-sm" @click="overlayClicked(slide)"></div>
          <div class="video-wrapper">
            <video controls :poster="slide.videoPoster" @loadedmetadata="videoLoaded"
              :ref="el => setVideoRef(index, el)">
              <source :src="slide.contentUrl" type="video/mp4" :aria-label="slide.title" />
            </video>
          </div>
        </div>
        <!--Simple image-->
        <div v-else-if="slide.slideType == 'image'" class="carousel-image">
          <img class="u-hidden@lg" :src="slide.mobileUrl" :alt="slide.title" />
          <img class="u-hidden u-visible@lg" :src="slide.contentUrl" :alt="slide.Title" />
        </div>
      </div>
    </v-slick-carousel>
  </div>
</template>

<script setup>
import 'v-slick-carousel/style.css';
import { ref, watch } from 'vue';
import { VSlickCarousel } from 'v-slick-carousel';

const slidesState = ref([])
const carousel = ref(null)
const firstSlideLoad = ref(false)

const props = defineProps({
  slides: {
    type: Array,
    required: true,
  },
  sliderSettings: {
    type: Object,
    default: () => ({
      widthDetection: 'manual',
      arrows: true,
      adaptiveHeight: true,
      focuseOnSelect: true,
      infinite: false,
      dots: true,
    }),
  },
  playOnSlide:{
    type:Boolean,
    default:false
  }
});


//watch the slides prop and copy it into state
//with our additional values
watch(
  () => props.slides,
  (newSlides) => {
    slidesState.value = newSlides.map((slide) => ({
      ...slide,
      isPlaying: false,
      videoElement: null,
    }));
  },
  {
    immediate: true,
  }
);

function videoLoaded(e) {
  //when a video finishes loading metadata, goto the current slide
  //so that v-slick will recompute adaptive height
  carousel.value.goTo(carousel.value.currentSlideGroupIndex);
}

function overlayClicked(slide) {
  //play the current slide if you click on the overlay
  slide.isPlaying = true;
  const el = slide.videoElement;
  if (el && el.tagName == "VIDEO") {
    el.play();
  }
}

function setVideoRef(index, el) {
  //set a reference to the video element into the state so we can control it
  slidesState.value[index].videoElement = el;
}

function beforeSlideChange() {
  
  //pause all slides before changing
  slidesState.value.forEach(slide => {
    slide.isPlaying = false;
    const el = slide.videoElement;
    if (el && el.tagName == "VIDEO") {
      el.pause();
    } else if (el && el.tagName == "IFRAME") {
      if (el.contentWindow) {
        el.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      }
    }
  });
}

function afterSlideChange(index){

  if(!firstSlideLoad.value){
    firstSlideLoad.value = true;
    return;
  }

  if(props.playOnSlide){
    const newSlide = slidesState.value[index];
    if(newSlide.videoElement){
      newSlide.isPlaying=true;
      if(newSlide.videoElement.tagName == "VIDEO"){
        newSlide.videoElement.play();
      } else if(newSlide.videoElement.tagName=="IFRAME"){
        newSlide.videoElement.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
      }
    }
  }

}

</script>

<style scoped>
/*.ads-video-bynder {}*/

.ads-video-yt {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
}

.ads-video-yt iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

:deep(.v-slick-arrow.disabled:before) {
  display: none;
}

:deep(.v-slick-arrow.disabled) {
  display: none;
}
</style>